// Single source of truth for the sales-forecast industry slugs, route
// titles, and URL building. Deliberately dependency-free: imported by the
// root routing module (without dragging the industry configs into the main
// bundle), by industry-config.ts, and by scripts/sitemap-static.ts via tsx.

export const SALES_FORECAST_BASE_PATH = 'sales-forecast';

// Title for the industry hub page served at the bare base path
export const SALES_FORECAST_INDEX_TITLE =
  'Business Location Analysis by Industry | Map AI';

// Route data key holding the industry slug for SalesForecastPageComponent
export const INDUSTRY_SLUG_KEY = 'industrySlug';

// Stripe success_url target after checkout — ask backend to point there
// (with the same ?session_id & ?payment-success=true params it uses today)
// instead of the bare hub path.
export const SALES_FORECAST_THANK_YOU_PATH = `${SALES_FORECAST_BASE_PATH}/thank-you`;

// sessionStorage key used to carry {industry, priceUsd} across the Stripe
// redirect round-trip, since the industry page that started checkout isn't
// the page Stripe redirects back to — the thank-you page stashes/reads this
// to show which report was bought and log the right GA event.
export const SALES_FORECAST_PENDING_ORDER_KEY = 'salesForecastPendingOrder';

export const SALES_FORECAST_ROUTES = [
  {
    slug: 'beauty-salon',
    title: 'Beauty Salon Location Analysis & Feasibility Study | Map AI',
  },
  {
    slug: 'restaurant',
    title: 'Restaurant Location Analysis & Feasibility Study | Map AI',
  },
  {
    slug: 'convenience-store',
    title: 'Convenience Store Site Selection & Feasibility Study | Map AI',
  },
  {
    slug: 'my-business',
    title: 'Feasibility Study for Any Business Location | Map AI',
  },
] as const;

export type SalesForecastSlug = (typeof SALES_FORECAST_ROUTES)[number]['slug'];

export function salesForecastPath(slug: SalesForecastSlug): string {
  return `${SALES_FORECAST_BASE_PATH}/${slug}`;
}
